const Footer = () => {
    return (<footer>
        <p>Developed and designed by &copy;Toma Iliev. Original game and levels by &copy;Thinking Rabbit.</p>
    </footer>)
}

export default Footer;